import ContactIdMappingResourceModel from '../../generated/types/model/resource/ContactIdMappingResourceModel';

export default class ContactIdMappingResourceViewModel extends ContactIdMappingResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
